import Vue from "vue";
// 动画
import animated from "animate.css";
// lodash
import _ from "lodash";
// 视频播放
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
// 自定义语言
import "video.js/dist/lang/zh-CN.js";
// 自定义视频样式
import "vue-video-player/src/custom-theme.css";

Vue.prototype._ = _;

Vue.config.productionTip = false;

Vue.use(animated);
Vue.use(VueVideoPlayer);
